import React from 'react';
import { PhoneCallsStore } from './phone-calls-store';

export const PhoneCallsContext = React.createContext<PhoneCallsStore | undefined>(undefined);
